// extracted by mini-css-extract-plugin
export default {"field":"styles_field__jo+4z","caption":"styles_caption__YtvpV","input":"styles_input__wDJNI","pictogram":"styles_pictogram__m7rbT"};